
import FileResultCard from './FileResultCard.vue';
import MxModal from '@/components/global/MxModal.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BetaChip from '../BetaChip.vue';
import { FileFlagStatus,  IFileGenerationHistory, IProjectFile, IFileClassification, MediaType } from '@/types/resource.types';

@Component({
    name: 'FileGenerationHistory',
    components: {
        FileResultCard,
        MxModal,
        BetaChip
    }
})
export default class FileGenerationHistory extends Vue {

    /* Props
    ============================================*/

    @Prop({type: Object, required: false})
    readonly history: IFileGenerationHistory;

    @Prop({type: String, required: false})
    readonly classifiedBrand:String;

    @Prop({type: String, required: false})
    readonly classifiedModel:String;

    @Prop({type: Object, required: false})
    readonly classifiedLastGeneration:IFileClassification;

    @Prop({type: Object, required: true})
    readonly file: IProjectFile;

    @Prop({type: Number, required: true})
    readonly mediaType: MediaType;

    /* Computed
    ============================================*/
    get comingSoon(): boolean{
        return this.mediaType === MediaType.Image;
    }
    get classifiedBrandString(){
        if(!this.classifiedBrand) return 'Confidence Threshold Not Met';
        if(this.classifiedBrand === 'None') return "Software Created";
        return this.classifiedBrand;
    }
    get classifiedModelString(){
        if(!this.classifiedModel) return 'Confidence Threshold Not Met';
        if(this.classifiedModel === 'None None') return "Software Created";
        return this.classifiedModel;
    }
    get fileIsFlagged(): boolean {
        return this.file?.flagStatus === FileFlagStatus.Flagged;
    }
    get lastGenerationDescription(): string | null{
        if(!this.classifiedLastGeneration) return null;
        return this.classifiedLastGeneration.predictedValue;
    }
    
    getPercentage(percent: number): string {
        if(!percent || percent < 0) return '0%';
        return (percent * 100).toFixed(2) + '%';
    }

}

